import * as Yup from 'yup';

export default Yup.object().shape({
  startDate: Yup.date().required(),
  endDate: Yup.date().required(),
  callerId: Yup.string().required(),
});
